module.exports = __webpack_public_path__ + "static/media/yamnaya_text_02.1bb09468.jpg";